export const COVERAGE_MAP_STRINGS = {
  'title.start': 'Tired of',
  'title.end': "property management? We're local here and ready for\u00a0you!",
  'explore.label': 'Explore Belong {region}',
  'region_under_construction.label': 'Region Under Construction',
  'learn_more.label': 'Learn More',
};
